import { Box, Card, Typography } from "@mui/material";
import PoliciesStyles from "./PoliciesStyles";
import { IPolicy } from "../../../models/user/dashboard/Dashboard";
import { useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import PolicyCard from "./PolicyCard/PolicyCard";
import rightArrowIcon from "../../../assets/viewAllArrow.svg";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const getPolicies = (policiesData: any) => {
  if (policiesData && policiesData.policyList) {
    let policies = [...policiesData.policyList];
    let sortedPolicies = policies.sort((a, b) => {
      if (
        a?.carrierPolicyStatus?.toLowerCase() <
        b?.carrierPolicyStatus?.toLowerCase()
      ) {
        return -1;
      }
      if (
        a?.carrierPolicyStatus?.toLowerCase() >
        b?.carrierPolicyStatus?.toLowerCase()
      ) {
        return 1;
      }
      return 0;
    });
    // .sort((a, b) => {
    //   if (a.lobCode.toLowerCase() < b.lobCode.toLowerCase()) {
    //     return -1;
    //   }
    //   if (a.lobCode.toLowerCase() > b.lobCode.toLowerCase()) {
    //     return 1;
    //   }
    //   return 0;
    // });
    if (sortedPolicies.length > 0) {
      return sortedPolicies;
    } else {
      return policiesData.policyList;
    }
  } else {
    return [];
  }
};

const Policies: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { policiesData } = useAppSelector(
    (store: RootState) => store.dashboard
  );

  const handleViewAllClick = useCallback(() => {
    navigate("/customer/policies");
  }, [navigate]);

  return (
    <>
      <Box sx={PoliciesStyles.policiesContainer}
        id="customerdashboard_policies-container"
        data-test-id="test-customerdashboard_policies-container"
        aria-label="Policies section"
      >
        <Box sx={PoliciesStyles.policiesContainerHeader}
          id="customerdashboard_policies-header"
          data-test-id="test-customerdashboard_policies-header"
          aria-label="Policies header"
        >
          <Typography sx={PoliciesStyles.heading}
            id="customerdashboard_policies-heading"
            data-test-id="test-customerdashboard_policies-heading"
            aria-label="List of policies heading"
          >
            {t("Here is your list of policies")}
          </Typography>
          {policiesData &&
          policiesData.policyList &&
          policiesData.policyList.length > 3 ? (
            <Box sx={PoliciesStyles.viewAll} onClick={handleViewAllClick}
              id="customerdashboard_policies-viewall-container"
              data-test-id="test-customerdashboard_policies-viewall-container"
              aria-label="View all policies section"
            >
              <Typography
                id="customerdashboard_policies-viewall-text"
                data-test-id="test-customerdashboard_policies-viewall-text"
                aria-label="Click to view all policies" 
                sx={PoliciesStyles.viweAllText}
              >
                {t("View All")}
              </Typography>
              <img 
                id="customerdashboard_policies-viewall-rightarrow-img"
                data-test-id="test-customerdashboard_policies-viewall-rightarrow-img"
                aria-label="Right arrow icon for view all policies"
                src={rightArrowIcon} 
                alt="right-arrow-icon" 
              />
            </Box>
          ) : (
            <></>
          )}
        </Box>
        {getPolicies(policiesData).length > 0 ? (
          <Box sx={PoliciesStyles.policies}
            id="customerdashboard_policies-list"
            data-test-id="test-customerdashboard_policies-list"
            aria-label="List of policies"
          >
            {getPolicies(policiesData)
              .slice(0, 4)
              .map((policy: IPolicy, index: number) => (
                <PolicyCard policy={policy} key={policy.policyId} />
              ))}
          </Box>
        ) : (
          <Card sx={PoliciesStyles.noPoliciesCard}
            id="customerdashboard_policies-empty-card"
            data-test-id="test-customerdashboard_policies-empty-card"
            aria-label="No policies available message"  
          >
            <Typography sx={PoliciesStyles.noPoliciesText}
              id="customerdashboard_policies-empty-text"
              data-test-id="test-customerdashboard_policies-empty-text"
              aria-label="No policies available"
            >
              {t("No Policies Available")}
            </Typography>
          </Card>
        )}
      </Box>
    </>
  );
};

export default Policies;
